// API-ul este servit de aceeași aplicație, sub /api.
export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export function apiUrl(path = '') {
  if (!path.startsWith('/')) path = '/' + path;
  return API_BASE_URL + path;
}
